import classNames from 'classnames'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import Product from '@src/quince-site-common/src/domains/Product'
import BaseProduct from '@src/quince-site-common/src/domains/Product/BaseProduct'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { useNewPdpDesignV2Bucket } from '@src/quince-site-pdp/src/templates/productPage/hooks/useShowNewPdpDesignV2'

import { getProductLink } from '../../molecules/productCard/productCard.helpers'
import { Button, BUTTON_SIZE, BUTTON_TYPES } from '../button'

import styles from './productCTA.module.scss'
interface DisplayButtonType {
  onClick: () => void
  className?: string
  showLoader?: boolean
  selectorKey?: string
  children?: string
  buttonRef?: any
  disabled?: boolean
  buttonType?: BUTTON_TYPES
  showNewPdpUI?: boolean
  buttonSize?: BUTTON_SIZE
  showNewPdpDesignV2?: boolean
  product?: Product
  selectedOptions?: ProductVariantOption[]
  setIsCartPopUpOpen?: (isCartOpen: boolean) => void
  isBuyNowPdp?: boolean
  isFromCartPopup?: boolean
}
export const ProductDisplayButton = ({
  children,
  onClick,
  className,
  showLoader,
  selectorKey,
  buttonRef,
  disabled = false,
  buttonType = BUTTON_TYPES.PRIMARY,
  showNewPdpUI = false,
  buttonSize = BUTTON_SIZE.LARGE,
  showNewPdpDesignV2,
  product,
  selectedOptions,
  setIsCartPopUpOpen,

  isFromCartPopup,
}: DisplayButtonType) => {
  const { t } = useTranslation('common')
  const newPdpV2Bucket = useNewPdpDesignV2Bucket()
  const showPdpV2UI = newPdpV2Bucket !== STATSIG_EXPERIMENTS_BUCKETS.CONTROL
  const { deviceType } = useDeviceInfo()
  const isMobile = deviceType === DEVICE_TYPES.MOBILE

  return (
    <>
      {isFromCartPopup && showPdpV2UI && !isMobile && (
        <div className={styles.viewProductDetailsContainer}>
          <span className={styles.viewProductDetailsContent}>
            <Link
              href={getProductLink(product as BaseProduct | Bundle, selectedOptions as ProductVariantOption[])}
              onClick={() => {
                setIsCartPopUpOpen && setIsCartPopUpOpen(false)
              }}
            >
              {t('view_full_product_details')}
            </Link>
          </span>
        </div>
      )}
      <Button
        className={classNames(
          styles.displayButtonWrapper,
          className,
          disabled && styles.productCTADisabled,
          showNewPdpUI && styles.displayButtonWrapper_adjustedPadding,
          showNewPdpDesignV2 && styles.displayButtonWrapper_newDesignV2,
        )}
        type={buttonType}
        size={buttonSize}
        disabled={disabled}
        round={true}
        onClick={onClick}
        showLoader={showLoader}
        selectorKey={selectorKey}
        buttonRef={buttonRef}
      >
        {children}
      </Button>
    </>
  )
}
